export default "__VITE_ASSET__BYBNMMQx__"